<template>
    <div class="view view__reports_show">
        <report-show/>
    </div>
</template>

<script>
import ReportShow from '@/components/ebs/reports/show/ReportShow'

export default {
  name: 'view-reports-show',
  components: { ReportShow },
  computed: {
    reportFilters () {
      return this.$store.getters.getReportGeneratedReportFilters
    }
  },
  methods: {
    getReportFilters () {
      let slug = this.$route.params.slug
      this.$store.dispatch('getReportGeneratedReportFilters', slug).finally(() => {
        this.$eventBus.$emit('stop-loading')
      })
    },
    generateReport () {
      let slug = this.$route.params.slug
      this.$store.dispatch('getReportGeneratedReportTable', slug)
    },
    clearReport () {
      this.$store.dispatch('clearReportGenerated')
    }
  },
  created () {
    this.getReportFilters()
    this.generateReport()
    this.$eventBus.$emit('start-loading')
  },
  beforeDestroy () {
    this.clearReport()
  }
}
</script>
